import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Ben wants to stop vaping but can’t do it on his own. Which is NOT a resource he can use to help him quit?  ',
  inputType: 'radio',
  options: [
    {
      label: 'family doctor or counselor',
    },
    {
      label: 'text message programs and apps',
    },
    {
      label: 'parents, teachers, and coaches',
    },
    {
      label: 'social media vaping pages',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[3].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'Human resources, text message programs, and professional help are all available to help you stop vaping.',
  },
  error: {
    title: 'Not quite.',
    body:
      'Human resources, text message programs, and professional help are all available to help you stop vaping. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 3',
  path: '/prepare/question-3',
  content: (
    <Fragment>
      <Intro
        title="Question 3"
        direction={'Select the item that best completes the statement.'}
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question3.js